module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Aviator-Lifestyle.6e3167de.jpeg";